"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
WebSocketProxy.$inject = ['$rootScope', 'config'];
function WebSocketProxy($rootScope, config) {
    // const connection = new WebSocket(config.server.ws)
    // connection.onopen = () => {
    //   connection.send('hey')
    // }
    // connection.onerror = (error) => {
    //   console.log(`WebSocket error: ${error}`)
    // }
    // connection.onmessage = (e) => {
    //   console.log(e.data)
    // }
}
exports.default = angular.module('profumo.notification', [])
    .run(WebSocketProxy);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/services/notification.js
// module id = 455
// module chunks = 0